import { BaseModal } from '@isdd/idsk-ui-kit'
import React, { useEffect, useState } from 'react'
import uniq from 'lodash/uniq'

import { FileHistoryView } from './FileHistoryView'

import { ConfigurationItemUi } from '@isdd/metais-common/api/generated/cmdb-swagger'
import { getGetHistoryQueryKey, useGetHistory } from '@isdd/metais-common/api/generated/dms-swagger'
import { getGetIdentitiesByLoginsBulkQueryKey, useGetIdentitiesByLoginsBulk } from '@isdd/metais-common/api/generated/iam-swagger'
import { useAuth } from '@isdd/metais-common/contexts/auth/authContext'

export interface IFileHistoryModalProps {
    onClose: () => void
    item: ConfigurationItemUi
    isOpen?: boolean
}

export const FileHistoryModal: React.FC<IFileHistoryModalProps> = ({ item, onClose, isOpen }) => {
    const { data, isLoading } = useGetHistory(item.uuid ?? '', { query: { queryKey: getGetHistoryQueryKey(item.uuid ?? ''), enabled: !!item.uuid } })
    const [tableData, setTableData] = useState(data?.versions ?? [])
    const [pageSize, setPageSize] = useState(10)
    const {
        state: { user },
    } = useAuth()
    const { data: identitiesData } = useGetIdentitiesByLoginsBulk(uniq(data?.versions?.map((itemName) => itemName.lastModifiedBy ?? '') ?? []), {
        query: {
            queryKey: getGetIdentitiesByLoginsBulkQueryKey(uniq(data?.versions?.map((itemName) => itemName.lastModifiedBy ?? '') ?? [])),
            enabled: !!data && user !== null,
        },
    })

    const namesData = identitiesData?.map((itemName) => {
        return {
            login: itemName.input ?? '',
            fullName: itemName.identity ? (itemName.identity?.firstName ?? '') + ' ' + (itemName.identity?.lastName ?? '') : (itemName.input ?? ''),
        }
    })

    const handlePagingSelect = (page: string) => {
        setPageSize(Number(page))
    }

    useEffect(() => {
        setTableData(data?.versions?.slice(0, pageSize) ?? [])
    }, [data?.versions, pageSize])

    return (
        <BaseModal isOpen={isOpen ?? true} close={onClose}>
            <FileHistoryView
                data={tableData}
                onClose={onClose}
                item={item}
                handlePagingSelect={handlePagingSelect}
                isLoading={isLoading}
                namesData={namesData}
            />
        </BaseModal>
    )
}
